import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";
import {Link} from "react-router-dom";

function Block0() {

    return (
            <section className="banner-section">
                <div className="auto-container">
                    <div className="row">
                        <div className="content-column col-lg-7 col-md-12 col-sm-12">
                            <div className="sec-title-outer layout-pt-60">
                                <div className="sec-title" style={{color: "#ffffff"}}>
                                    <Link to="/" title="Accueil Hotline Talents Handicap">
                                        <img src="/images/hotline-TH02.png" alt="Hotline Talents Handicap" width={"250px"}
                                             className="homepage"/>
                                    </Link>
                                    <h2 className="homepage white mt-20">Offrez à vos collaborateurs un espace
                                        dédié à leurs questions sur le handicap !</h2>


                                    <div className="text white mt-30">
                                        La Hotline Talents Handicap accompagne vos collaborateurs sur les questions
                                        liées au handicap, grâce à un espace tout en un, pour s’informer et échanger
                                        avec des experts.
                                        <ul className="list-style-one homepage white mt-3">
                                            <li>Échange confidentiel avec des experts Talents Handicap</li>
                                            <li>Espace web dédié et personnalisé</li>
                                            <li>Accès aux informations et ressources utiles (FAQ, contacts,
                                                événements…)
                                            </li>
                                        </ul>
                                    </div>
                                    <ContactModal textButton="Demander une présentation personnalisée" showText={false}
                                                  small="small" linkPageContact={false} iframe={false} couleur={true}
                                                  formModal={true}/>
                                </div>
                            </div>
                        </div>

                        <div className="image-column col-lg-5 col-md-12">

                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Block0;
